function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrainAmbulanceService(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 512.001 512.001",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M443.947 355.098H10.875C4.869 355.098 0 350.229 0 344.223v-23.069h480.215l-4.988 12.654a33.624 33.624 0 0 1-31.28 21.29z",
    style: {},
    fill: "#c3c6c8",
    "data-original": "#c3c6c8"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 301.585,
    cy: 355.095,
    r: 20.228,
    style: {},
    fill: "#333e48",
    "data-original": "#333e48"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 342.044,
    cy: 355.095,
    r: 20.228,
    style: {},
    fill: "#333e48",
    "data-original": "#333e48"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 117.547,
    cy: 354.52,
    r: 20.228,
    style: {},
    fill: "#333e48",
    "data-original": "#333e48"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 158.006,
    cy: 354.52,
    r: 20.228,
    style: {},
    fill: "#333e48",
    "data-original": "#333e48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 321.154v23.069h468.695a33.589 33.589 0 0 0 6.532-10.415l4.988-12.654H0z",
    style: {
      opacity: 0.15,
      enableBackground: "new"
    },
    fill: "#000000",
    opacity: 1,
    "data-original": "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.128 136.678H10.875C4.869 136.678 0 141.548 0 147.554v186.737h480.215c20.233 0 35.313-18.66 31.065-38.442a110.041 110.041 0 0 0-20.333-43.954l-53.619-69.785a116.27 116.27 0 0 0-92.2-45.432z",
    style: {},
    fill: "#f0efef",
    "data-original": "#f0efef"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 155.387h249.742a28.633 28.633 0 0 1 22.35 10.734l7.16 8.94H0v-19.674z",
    style: {},
    fill: "#ff495c",
    "data-original": "#ff495c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 287.053h379.455v16.27H0z",
    style: {},
    fill: "#ffd13f",
    "data-original": "#ffd13f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m490.946 251.895-53.619-69.785a116.273 116.273 0 0 0-92.2-45.431l47.999 71.611c26.733 39.883 68.31 66.687 114.689 75.086a109.966 109.966 0 0 0-16.869-31.481z",
    style: {},
    fill: "#ff495c",
    "data-original": "#ff495c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.328 182.11a116.58 116.58 0 0 0-5.884-7.048h-60.588l22.272 33.227a175.777 175.777 0 0 0 14.311 18.534h64.245l-34.356-44.713z",
    style: {},
    fill: "#333e48",
    "data-original": "#333e48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m365.149 208.289-18.676-27.863a12.105 12.105 0 0 0-10.055-5.365h-11.686a7.26 7.26 0 0 0-7.259 7.26v121.975a7.26 7.26 0 0 0 7.259 7.26h47.462a7.26 7.26 0 0 0 7.259-7.26v-67.83c0-5.977-2-11.789-5.727-16.461a175.204 175.204 0 0 1-8.577-11.716z",
    style: {},
    fill: "#c3c6c8",
    "data-original": "#c3c6c8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.726 220.005a174.967 174.967 0 0 1-8.577-11.717l-18.676-27.863a12.105 12.105 0 0 0-10.055-5.365h-11.686a7.26 7.26 0 0 0-7.259 7.26v44.502h60.15a26.108 26.108 0 0 0-3.897-6.817zM358.4 273.073a8.134 8.134 0 0 1-8.135-8.135v-17.627a8.134 8.134 0 0 1 8.135-8.135 8.134 8.134 0 0 1 8.135 8.135v17.627a8.134 8.134 0 0 1-8.135 8.135zM230.405 175.061h48.847c6.922 0 12.534 5.611 12.534 12.532v26.696c0 6.921-5.611 12.532-12.534 12.532h-48.847c-6.921 0-12.534-5.611-12.534-12.532v-26.696c.001-6.921 5.613-12.532 12.534-12.532z",
    style: {},
    fill: "#333e48",
    "data-original": "#333e48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.339 175.061h64.877c9.038 0 16.364 7.326 16.364 16.364v103.767c0 9.036-7.326 16.364-16.364 16.364h-64.877c-9.038 0-16.364-7.326-16.364-16.364V191.425c.001-9.038 7.326-16.364 16.364-16.364z",
    style: {},
    fill: "#c3c6c8",
    "data-original": "#c3c6c8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 175.061h45.15c6.922 0 12.534 5.611 12.534 12.532v26.696c0 6.921-5.611 12.532-12.534 12.532H0v-51.76zM170.216 175.061h-64.877c-9.038 0-16.364 7.326-16.364 16.364v35.399h97.603v-35.399c.002-9.038-7.324-16.364-16.362-16.364z",
    style: {},
    fill: "#333e48",
    "data-original": "#333e48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.641 175.059h16.27v136.497h-16.27z",
    style: {
      opacity: 0.2,
      enableBackground: "new"
    },
    fill: "#000000",
    opacity: 1,
    "data-original": "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.328 182.11a116.58 116.58 0 0 0-5.884-7.048h-.172l-36.129 36.128a176.4 176.4 0 0 0 12.296 15.635h44.019l11.438-11.438-25.568-33.277zM291.746 186.82l-40.003 40.003h27.509c6.922 0 12.534-5.612 12.534-12.534v-26.696c-.001-.259-.025-.515-.04-.773zM346.472 180.426a12.102 12.102 0 0 0-10.054-5.365h-11.686a7.26 7.26 0 0 0-7.259 7.26v44.502h9.473l30.309-30.31-10.783-16.087zM170.216 175.061h-18.163l-51.762 51.762h51.085l35.203-35.204v-.195c.001-9.037-7.325-16.363-16.363-16.363zM45.15 175.061H27.179L0 202.24v24.583h16.112l41.375-41.375c-1.019-5.897-6.149-10.387-12.337-10.387z",
    style: {
      opacity: 0.15,
      enableBackground: "new"
    },
    fill: "#ffffff",
    "data-original": "#ffffff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrainAmbulanceService);
export default __webpack_public_path__ + "static/media/train_ambulance_service.e6de9ae0e4ce5fe48a241fd8e51902fb.svg";
export { ForwardRef as ReactComponent };